export enum TimeFrameType {
  CURRENT_MONTH = 'current_month',
  LAST_MONTH = 'last_month',
  LAST_3_MONTHS = 'last_3_months',
  CURRENT_YEAR = 'current_year',
  CUSTOM_TIMEFRAME = 'custom_timeframe',
}
